import { render, staticRenderFns } from "./ActorCard.vue?vue&type=template&id=b1214c1e&scoped=true&"
import script from "./ActorCard.vue?vue&type=script&lang=ts&"
export * from "./ActorCard.vue?vue&type=script&lang=ts&"
import style0 from "./ActorCard.vue?vue&type=style&index=0&id=b1214c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1214c1e",
  null
  
)

export default component.exports